import { firebase } from '../config/firebase.client';
import { showAlert } from './alert';


export const fetchPlacesAutocomplete = async (searchKeyword, location) => {
    if (__DEV__) console.log('[DEV] fetchPlacesAutocomplete chamada');
    location = location ? `${location.location.lat},${location.location.lng}` : '';

    try {
        const data = await firebase.callFunction('googleapis-googleApisAutocomplete', {
            searchKeyword,
            location,
        });

        if (data && data.searchResults) return data.searchResults;
        return 'Nenhum resultado encontrado';
    } catch (error) {
        const msg = error.message || 'Erro na função fetchPlacesAutocomplete';
        console.error(msg);
        showAlert(msg);
    }
};

export const fetchCoordsfromPlace = async (place_id) => {
    if (__DEV__) console.log('[DEV] fetchCoordsfromPlace chamada');
    try {
        const data = await firebase.callFunction('googleapis-googleApisGetCoords', { place_id });
        if (data && data.coords) return data.coords;

        const msg = 'Nenhuma coordenada encontrada';
        console.error(msg);
        showAlert(msg);
    } catch (error) {
        const msg = error.message || 'Erro na função fetchCoordsfromPlace';
        console.error(msg);
        showAlert(msg);
    }
};

export const fetchAddressfromCoords = async (latlng) => {
    if (__DEV__) console.log('[DEV] fetchAddressfromCoords chamada');
    try {
        const data = await firebase.callFunction('googleapis-googleApisGetAddress', { latlng });
        if (data && data.address) return data.address;

        const msg = 'Nenhum endereço encontrado';
        console.error(msg);
        showAlert(msg);
    } catch (error) {
        const msg = error.message || 'Erro na função fetchAddressfromCoords';
        console.error(msg);
        showAlert(msg);
    }
};

export const getDistanceMatrix = async (startLoc, destLoc) => {
    if (__DEV__) console.log('[DEV] getDistanceMatrix chamada');
    try {
        const data = await firebase.callFunction('googleapis-googleApisGetDistanceMatrix', {
            start: startLoc,
            dest: destLoc,
        });

        if (data) return data;
        const msg = 'Erro ao obter distância';
        console.error(msg);
        showAlert(msg);
    } catch (error) {
        const msg = error.message || 'Erro na função getDistanceMatrix';
        console.error(msg);
        showAlert(msg);
    }
};

export const getDirectionsApi = async (startLoc, destLoc, waypoints) => {
    if (__DEV__) console.log('[DEV] getDirectionsApi chamada');
    try {
        const body = { start: startLoc, dest: destLoc };
        if (waypoints) body.waypoints = waypoints;

        const data = await firebase.callFunction('googleapis-googleApisGetDirections', body);

        if (data && data.distance_in_km !== undefined) return data;
        const msg = 'Erro ao obter direções';
        console.error(msg);
        showAlert(msg);
    } catch (error) {
        const msg = error.message || 'Erro na função getDirectionsApi';
        console.error(msg);
        showAlert(msg);
    }
};